import { Theme } from '@mui/material/styles';

export const sxBackBtn = {
  display: { xs: 'flex', md: 'none' },
};

export const sxConstainer = (theme: Theme) => ({
  borderRadius: 1.5,
  bgcolor: { xs: 'background.default', md: theme.palette.grey[800] },
  flexDirection: 'column',
  flexGrow: 1,
  p: 0,
});

export const sxHeaderContainer = {
  p: { xs: 0, md: 2.5 },
  pb: { xs: 1, md: 2 },
  bgcolor: { xs: 'background.default', md: 'transparent' },
  borderTopLeftRadius: { xs: 12, md: 0 },
  borderTopRightRadius: { xs: 12, md: 0 },
  width: '100%',
};

export const sxHeaderContainerLine = {
  p: 0,
};

export const sxContent = (theme: Theme) => ({
  pr: { xs: 0, md: 2.5 },
  pb: { xs: 0, md: 2.5 },
  pl: { xs: 0, md: 2.5 },
  pt: 0,
  bgcolor: { xs: theme.palette.grey[800], md: 'transparent' },
  borderBottomLeftRadius: { xs: 12, md: 0 },
  borderBottomRightRadius: { xs: 12, md: 0 },
});

export const sxImageContainer = {
  position: 'relative',
  bgcolor: 'black',
  width: 1,
  height: 1,
  borderRadius: 1,
};

export const sxPX2 = {
  px: 2,
};

export const sxNotSelectedContainer = {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
};

export const notSelectedImg = {
  height: '160px',
  width: '160px',
};
